import {RouterView} from './RouterView.js';
import Index from '@/components/views/acquisition/Index';
import Create from '@/components/views/acquisition/Create';

export default {
    path: 'solicitudes',
    component: RouterView,
    children:[
        {
            path: '',
            component: Index
        },
         {
            path: 'alta',
            component: Create,
            name:'solicitudesAlta',
        },
        {
            path: 'editar/:id',
            component: Create,
	        props: true,
	        name:'solicitudesEditar',
        }
    ]

}
